import { meilisearchAutocompleteClient } from '@meilisearch/autocomplete-client'
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch'
import { z } from 'zod'

const { NEXT_PUBLIC_MEILISEARCH_API_KEY, NEXT_PUBLIC_MEILISEARCH_URL } = z
  .object({
    NEXT_PUBLIC_MEILISEARCH_URL: z
      .string()
      .default('MISSING NEXT_PUBLIC_MEILISEARCH_URL'),
    NEXT_PUBLIC_MEILISEARCH_API_KEY: z
      .string()
      .default('MISSING NEXT_PUBLIC_MEILISEARCH_API_KEY')
  })
  .parse({
    NEXT_PUBLIC_MEILISEARCH_API_KEY:
      process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY,
    NEXT_PUBLIC_MEILISEARCH_URL: process.env.NEXT_PUBLIC_MEILISEARCH_URL
  })

export const searchClient = meilisearchAutocompleteClient({
  url: NEXT_PUBLIC_MEILISEARCH_URL,
  apiKey: NEXT_PUBLIC_MEILISEARCH_API_KEY
})

export const { searchClient: instantSearchClient } = instantMeiliSearch(
  NEXT_PUBLIC_MEILISEARCH_URL,
  NEXT_PUBLIC_MEILISEARCH_API_KEY,
  { finitePagination: true }
)

export const searchIndex = 'fra_events'

export const defaultSortBy =
  'fra_events:eventIsFeatured:desc,fra_events:editionLiveStartDateTimestamp:asc'
